const ctxDropdownModule = angular.module('com.comtrade.shared.ctxDropdown', []);

ctxDropdownModule.directive('ctxDropdown', require('./ctxDropdown.directive.js'));
ctxDropdownModule.directive('ctxDropdownTrigger', require('./ctxDropdownTrigger.directive'));
ctxDropdownModule.directive('ctxDropdownList', require('./ctxDropdownList.directive'));
ctxDropdownModule.directive('ctxDropdownListItem', require('./ctxDropdownListItem.directive'));

module.exports = ctxDropdownModule;



// WEBPACK FOOTER //
// ./src/shared/ctxDropdown/ctxDropdown.module.js